export default __webpack_public_path__ + "static/subset-UniNeueHeavy-42f7897ac71ded556cd25ade9dce319f.woff2";